module.exports = __webpack_public_path__ + "static/media/urban-farming.9092a4ed.jpg";